import React from "react";
import "./styles.css";

const index = () => {
  return (
    <div className="under-development">
      <h1>Under Development</h1>
      <p>
        The mobile version of this website is currently under development.
        Please visit us from a larger screen.
      </p>
    </div>
  );
};

export default index;
